"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Teaser = /** @class */ (function () {
    function Teaser(documentObject) {
        this.document = documentObject;
        this.loadVideo();
    }
    Teaser.prototype.loadVideo = function () {
        var _this = this;
        var videoElements = this.document.querySelectorAll('.js-teaser-video video');
        var youtubeVideoElements = this.document.querySelectorAll('.js-teaser-video .youtube-video');
        if (videoElements) {
            videoElements.forEach(function (video) {
                if (video) {
                    // Set video current time to 1 second
                    video.currentTime = 1;
                }
            });
        }
        if (youtubeVideoElements) {
            this.addYoutubeApiIfNotExist();
            setTimeout(function () {
                // TODO: fix this event (window as { [key: string]: any })['onYouTubeIframeAPIReady'] = () => {
                var YT = window['YT'];
                if (YT !== null && YT !== undefined) {
                    youtubeVideoElements.forEach(function (element) {
                        var parent = element.parentElement;
                        var videoId = element.dataset.video;
                        var player = new YT.Player(element, {
                            host: 'https://www.youtube.com',
                            height: '390',
                            width: '640',
                            videoId: videoId,
                            origin: window.location.origin,
                            widget_referrer: window.location.origin,
                            playerVars: {
                                fs: 0,
                                origin: window.location.origin,
                                start: 2,
                                disablekb: 1,
                                autoplay: 0,
                                controls: 0,
                                mute: 1,
                                loop: 0,
                                modestbranding: 1,
                                enablejsapi: 1,
                                rel: 0,
                                showinfo: 0,
                                version: 1
                            },
                            events: {
                                'onStateChange': onStateChange,
                                'onPlayerReady': onPlayerReady
                            }
                        });
                        function onStateChange(event) {
                        }
                        function onPlayerReady(event) {
                        }
                        _this.setIframeSize(parent);
                    });
                }
            }, 1000);
        }
    };
    Teaser.prototype.addYoutubeApiIfNotExist = function () {
        var url = "https://www.youtube.com/iframe_api";
        var scripts = document.getElementsByTagName('script');
        for (var i = scripts.length; i--;) {
            if (scripts[i].src == url)
                return true;
        }
        var tag = document.createElement('script');
        tag.src = url;
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    };
    Teaser.prototype.setIframeSize = function (element) {
        var iframe = element.querySelector('iframe');
        if (iframe) {
            iframe.style.height = 'calc(100% + 120px)';
            iframe.style.width = '100%';
            iframe.style.left = '0';
            iframe.style.top = '-60px';
            iframe.style.position = 'absolute';
        }
    };
    return Teaser;
}());
exports.default = Teaser;
